import { render, staticRenderFns } from "./Setting-list-type-user.vue?vue&type=template&id=2f2826ba"
import script from "./Setting-list-type-user.vue?vue&type=script&lang=js"
export * from "./Setting-list-type-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports